import React, {useRef, useState} from 'react';
import styles from './Toggletip.module.scss';
import CloseIcon from '../../assets/icons/12/cross.svg';
import {ToggletipPropsInterface} from "./Toggletip.props.interface";

const Toggletip: React.FC<ToggletipPropsInterface> = (
    {
        direction = 'top',
        trigger = undefined,
        children = undefined
    }) => {

    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef(null);
    const tooltipContentRef = useRef(null);

    const handleOpen = () => {
        setIsVisible(true);
    };

    const handleClose = () => {
        setIsVisible(false)
    }

    const handleBlur = (e: any) => {
        const currentTarget = e.currentTarget;
        const relatedTarget = e.relatedTarget || document.activeElement;

        currentTarget && !currentTarget.contains(relatedTarget) ? setIsVisible(false) : null
    };

    return (
        <span
            ref={tooltipRef}
            tabIndex={0}
            onFocus={handleOpen}
            onBlur={handleBlur}
            className={[
                styles.container,
                styles[direction],
            ].filter(Boolean).join(' ')}>

            {trigger}

            <span
                ref={tooltipContentRef}
                className={[
                    styles.content,
                    isVisible ? styles.isVisible : null
                ].filter(Boolean).join(' ')}>

                {children}

                <button
                    className={styles.close}
                    onClick={handleClose}>
                    <CloseIcon/>
                </button>
            </span>
        </span>
    );
};

export default Toggletip;
